import { createSelector } from "reselect";

// types
import IRootState from "models/IRootState";

export const isLoadingSelector = createSelector(
  (state: IRootState) => state.app,
  (app) => app.isLoading
);

export const employeesSelector = createSelector(
  (state: IRootState) => state.employees,
  (employees) =>
    employees.data.sort((a: any, b: any) => {
      return a?.employee_id - b?.employee_id;
    })
);

export const employeesOptionsSelector = createSelector(
  (state: IRootState) => state.employees,
  (employees) =>
    employees.data.map((d) => ({ id: d.employee_id, name: d.name }))
);

export const entitiesListSelector = createSelector(
  (state: IRootState) => state.entitiesList,
  (entitiesList) => entitiesList.data
);
export const employeepersonaldetailsSelector = createSelector(
  (state: IRootState) => state.employeePersonalDetails,
  (employeePersonalDetails) => employeePersonalDetails.data
);

export const designationListSelector = createSelector(
  (state: IRootState) => state.designationsList,
  (designationsList) => designationsList.data
);

export const employeeprofessionaldetailsSelector = createSelector(
  (state: IRootState) => state.employeeProfDetails,
  (employeeProfDetails) => employeeProfDetails.data
);

export const projectSelector = createSelector(
  (state: IRootState) => state.projects,
  (projects) => projects.data
);

export const subprojectSelector = createSelector(
  (state: IRootState) => state.subprojects,
  (projects) => projects.data
);

export const skillSelector = createSelector(
  (state: IRootState) => state.skills,
  (skills) => skills.data
);

export const worktypeSelector = createSelector(
  (state: IRootState) => state.worktypes,
  (worktypes) => worktypes.data
);

export const locationSelector = createSelector(
  (state: IRootState) => state.locationsList,
  (locationsList) => locationsList.data
);

export const moduleSelector = createSelector(
  (state: IRootState) => state.modulesList,
  (modulesList) => modulesList.data
);

export const employeeManagementSelector = createSelector(
  (state: IRootState) => state.employeeManagement,
  (employeeManagement) => employeeManagement.data
);

export const userTrackingFiltersSelector = createSelector(
  (state: IRootState) => state.userTracking,
  (userTracking) => userTracking.data
);

export const filtersSelector = createSelector(
  (state: IRootState) => state.filterReducer,
  (filterReducer) => filterReducer
);

// export const naturalAnchorsPaymentFiltersSelector = createSelector(
//   (state: IRootState) => state.filterReducer.naturalAnchorsPayment,
//   (naturalAnchorsPayment) => naturalAnchorsPayment
// );
